import { SET_CUST_FUND_DETAIL } from "./constant";

export const setCustFundDetail = payload => {
  return {
    type: SET_CUST_FUND_DETAIL,
    payload
  };
};
